module.exports = __webpack_public_path__ + "static/media/0.638d1ef7.jpg";